<template>
    <div class="about-landing">
        <about-head/>
        <div class="sticker-title__pos">
            <img class="sticker-title" src="~@/assets/sticker-title.png">
            <img class="sticker-subtitle" src="~@/assets/sticker-subtitle.png">
        </div>
        <div class="indicator" @click="$emit('next')">
            <span class="indicator__label">scroll down</span>
            <img class="indicator__sticker" src="~@/assets/sticker-down.svg">
        </div>
    </div>
</template>

<script>
import AboutHead from './AboutHead'

export default {
    name: 'AboutLanding',
    components: {
        AboutHead
    },
    data() {
        return {
            share: false
        }
    },
}
</script>

<style scoped lang="scss">
@import '~@/styles/_parts';

.about-landing {
    height: 100%;
    @include modifier(transit) {
        .indicator {
            opacity: 0;
            visibility: hidden;
        }
    }
    @include modifier(mounted) {
        .sticker-subtitle {
            opacity: 1;
            visibility: visible;
        }
        .sticker-title__pos {
            transform: translateY(-50%);
        }
    }
}

.brand {
    width: em(288);
    position: absolute;
    top: 24px;
    right: 0;
    left: 0;
    margin: auto;
    transform: scale(0.25);
    transform-origin: top center;
    @include media(992) {
        width: em(300);
        top: 24px;
    }
}
.sticker-title__pos {
    width: em(204);
    margin: auto;
    padding-bottom: em(60);
    position: absolute;
    top: 50%;
    right: 0;
    left: 0;
    transform: translateY(calc(-50% + #{em(60)}));
    transition: transform 300ms $ease;
    z-index: 5;
    @include media(768) {
        width: em(340);
        padding-bottom: 0;
    }
}
.sticker-title {
    width: 100%;
    display: block;
}
.sticker-subtitle {
    width: em(100);
    display: block;
    margin: em(32) auto 0;
    opacity: 0;
    transition: opacity 195ms $ease, visibility 195ms $ease;
    transition-delay: 500ms;
    visibility: hidden;
    @include media(768) {
        font-size: 150%;
    }
}

.indicator {
    width: em(100);
    cursor: pointer;
    margin: auto;
    position: absolute;
    right: 0;
    bottom: calc(#{em(70)} + #{(46vh / 6.4)});
    left: 0;
    text-align: center;
    transition: opacity 195ms $ease, visibility 195ms $ease;
    z-index: 5;
    @include media(992) {
        bottom: em(88);
    }

    .indicator__label {
        color: #fff;
        font-size: em(14);
        opacity: .5;
        white-space: nowrap;
        @include g-text-shadow();
        @include media(992) {
            font-size: em(20);
        }
    }
    .indicator__sticker {
        display: block;
        margin: em(4) auto;
    }
}

.stickers {
    width: 100%;
    height: 100%;
    position: relative;
}
.sticker {
    position: absolute;
    visibility: hidden;

    @include modifier(n1) {
        width: em(182);
    }
    @include modifier(n2) {
        width: em(165);
    }
    @include modifier(n3) {
        width: em(208);
    }
    @include modifier(n4) {
        width: em(155);
    }
    @include modifier(n5) {
        width: em(126);
    }
}
</style>